import React from 'react';
import { DataForDesignDrawingsManifold } from '../../designs/data-for-design-drawings/dataForDesignDrawingsResponse';
import { getManifoldDisplayName } from '../helpers/manifoldHelpers';
import { ManifoldDiagramWithTable } from './ManifoldDiagramWithTable';
import { PdfDetailResponse } from '../PdfDataResponse';
import { PdfPage } from './PdfPage';
import { SidebarDetails } from '../sidebar/Sidebar';

type Props = {
  manifolds: Array<DataForDesignDrawingsManifold>;
  pdfDetail: PdfDetailResponse;
  pagesBeforeDiagram: number;
  totalNumberOfPages: number;
};

export const ManifoldsDiagram = ({ manifolds, pdfDetail, pagesBeforeDiagram, totalNumberOfPages }: Props) => {
  const getSidebarDetails = (manifold: DataForDesignDrawingsManifold, index: number): SidebarDetails => ({
    pageName: getManifoldDisplayName(manifold.name),
    pdfDetail,
    pageNumber: index + 1 + pagesBeforeDiagram,
    totalNumberOfPages,
    type: 'Manifold',
  });

  return (
    <>
      {manifolds.map((manifold, index) => (
        <PdfPage key={manifold.manifoldId} sidebarDetails={getSidebarDetails(manifold, index)}>
          <ManifoldDiagramWithTable manifold={manifold} />
        </PdfPage>
      ))}
    </>
  );
};
